// extracted by mini-css-extract-plugin
module.exports = {"update-button":"OrganizationLayout_update-button__3J2F-","layout-container":"OrganizationLayout_layout-container__39VA4"};